import styled from 'styled-components'
import Add from '@material-ui/icons/Add'
import ConfirmButton from 'components/Buttons/ConfirmButton'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width:100%;
  justify-content: stretch;
`

export const AddIcon = styled(Add)``

export const AddLocation = styled(ConfirmButton)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  width: fit-content;
  line-height: 25px;
  margin: 20px auto;
  background-color: #346c84;
  border-radius: 20px;
  color: #eff5f7;
`
